/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tts_Tool_Result_Ready_TitleInputs */

const en_tts_tool_result_ready_title = /** @type {(inputs: Tts_Tool_Result_Ready_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Audio is ready`)
};

const es_tts_tool_result_ready_title = /** @type {(inputs: Tts_Tool_Result_Ready_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Audio listo`)
};

/**
* | output |
* | --- |
* | "Audio is ready" |
*
* @param {Tts_Tool_Result_Ready_TitleInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const tts_tool_result_ready_title = /** @type {((inputs?: Tts_Tool_Result_Ready_TitleInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tts_Tool_Result_Ready_TitleInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_tts_tool_result_ready_title(inputs)
	return en_tts_tool_result_ready_title(inputs)
});